export const REPORTS_LOADED = "reports/reportsLoaded"
export const REPORTS_ADDED = "reports/reportsAdded"
export const REPORT_UPDATED = "reports/reportUpdated"
export const REPORTS_DELETED = "reports/reportsDeleted"